import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import SendPharmacyIcon from "../../../images/icons/SendPharmacyIcon.svg";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  EPAConfirmPrescriptions,
  EPAConfirmPrescriptionsForRefills,
  EPAHoldingSendToPharmacy,
  EPAHoldingSendToPharmacyForRefills,
} from "../../../Apis/AuthApiServices";
import { PharmacyDetailsList } from "../../../components/Content";
import {
  ContentStyle,
  HtmlTooltip,
  ScrollBarStyle,
  SummaryBox,
  SummaryInfo,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import ShowIcon from "@mui/icons-material/Add";
import HideIcon from "@mui/icons-material/Remove";
import { DialogPopup } from "../../../components/DialogPopup";
import AdverseEffectPOPUp from "../../../components/AdverseEffectPOPUp";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { useDispatch, useSelector } from "react-redux";
import EPCSAlert from "../../../components/EPCSAlert";
import { useSearchParams } from "react-router-dom";
import DrugAllergyInteractions from "../../../components/DrugAllergyInteractions";
import DrugToFoodInteractionPopUp from "../../../components/DrugToFoodInteractionPopUp";
import { IDME_URL_DOMAIN, IDME_URL_END } from "../../../Apis/Constants";
import IDME from "../../../components/IDME";
import { clearIdmePreferenceState } from "../../../Redux/Slice/IdmeSlice";
import { saveAsPreferenceApi } from "../../../Apis/Idme2FA";

export default function EPAHoldingQueueConfirmPresctiptions(props: any) {
  const Alert2FA = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/sendToIdMe?domain=drx.domain.ux.upgrade.${IDME_URL_END}.epa`;
  //const { state }: any = useLocation();
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const doctorId: any = localStorage.getItem("doctorId");
  const clinicId: any = sessionStorage.getItem("clinicId");
  const [data, setData] = useState<any>([]);
  const [iDmePopup, setIDMEPopup] = useState<boolean>(false);
  const [drugIdforadverse, setDrugIdForAdverse] = useState("");
  const [patientEduPopUp, setPatientEduPopUp] = useState(false);
  const [foodPopUp, setFoodPopUp] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [EPASendToPharmacyData, setEPASendToPharmacyData] = useState([]);
  const [sendToPharmacyError, setSendToPharmacyError] = useState("");
  const [load, setLoad] = useState(false);
  const [faPopUp, setFaPopUp] = useState<boolean>(false);
  const [openInfo, setOpenInfo] = useState<boolean[]>([]);
  const [adverseEffectPopUp, setAdverseEffectPopUp] = useState(false);
  const [prescriptionStatusPopUp, setPrescriptionStatusPopUp] = useState(false);
  const [
    sendTOPharmacyPrescriptionStatusPopUp,
    setsendTOPharmacyPrescriptionStatusPopUp,
  ] = useState(false);
  const [verifiedIdmeUuid, setVerifiedByIdmeUuid] = useState<string | null>(
    null
  );

  const handleShowSentPopupClick = () => {
    setFaPopUp(true);
  };
  const handleHideSentPopupClick = () => {
    setFaPopUp(false);
  };

  const handleInfoClick = (index: number): void => {
    setOpenInfo((openInfo) => {
      const newOpenInfo = [...openInfo];
      newOpenInfo[index] = !newOpenInfo[index];
      return newOpenInfo;
    });
  };
  const handleShowprescriptionStatusPopUpClick = () => {
    setPrescriptionStatusPopUp(true);
  };
  const handleHideprescriptionStatusPopUpClick = () => {
    setPrescriptionStatusPopUp(false);
  };

  const handleShowsendTOPharmacyPrescriptionStatusPopUpClick = () => {
    setsendTOPharmacyPrescriptionStatusPopUp(true);
  };
  const handleHidesendTOPharmacyPrescriptionStatusPopUpClick = () => {
    setsendTOPharmacyPrescriptionStatusPopUp(false);
    navigate("/epaholdingqueue");
    localStorage.removeItem("epaconfirmpresctions-data");
  };
  const handleShowAdverseEffectPopUpClick = () => {
    setAdverseEffectPopUp(true);
  };
  const handleHideAdverseEffectPopUpClick = () => {
    setAdverseEffectPopUp(false);
  };
  const handleShowIDMEPopupClick = () => {
    setIDMEPopup(true);
  };

  const handleShowPatientEduPopUpClick = () => {
    setPatientEduPopUp(true);
  };
  const handleHidePatientEduPopUpClick = () => {
    setPatientEduPopUp(false);
  };

  const handleShowFoodPopUpClick = () => {
    setFoodPopUp(true);
  };
  const handleHideFoodPopUpClick = () => {
    setFoodPopUp(false);
  };
  const handleHideIDMEPopupClick = () => {
    setIDMEPopup(false);
    setTimeout(() => {
      dispatch(clearIdmePreferenceState());
    }, 1000);
  };
  const epaConfirmPrescription = async () => {
    const data = JSON.parse(
      localStorage.getItem("epaconfirmpresctions-data")!
    )?.rowData;
    try {
      setLoading(true);
      const bodyData = {
        doctorId: doctorId,
        epaIds: data,
        selectedAddress: clinicId,
      };
      const result = await EPAConfirmPrescriptions(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setLoading(false);
        const authCheck: any = searchParams.get("authorization");
        if (authCheck == "true") {
          handleHideprescriptionStatusPopUpClick();
        } else {
          handleShowprescriptionStatusPopUpClick();
        }
      } else {
        setData([]);
        setLoading(false);
      }
    } catch (error) {
      setData([]);
      setLoading(false);
    }
  };
  const epaConfirmPrescriptionForRefills = async () => {
    const data = JSON.parse(
      localStorage.getItem("epaconfirmpresctions-data")!
    )?.rowData;
    try {
      setLoading(true);
      const bodyData = {
        doctorId: doctorId,
        epaIds: data,
        selectedAddress: clinicId,
      };
      const result = await EPAConfirmPrescriptionsForRefills(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setLoading(false);
        const authCheck: any = searchParams.get("authorization");
        if (authCheck == "true") {
          handleHideprescriptionStatusPopUpClick();
        } else {
          handleShowprescriptionStatusPopUpClick();
        }
      } else {
        setData([]);
        setLoading(false);
      }
    } catch (error) {
      setData([]);
      setLoading(false);
    }
  };
  const prescriptionsEPAHoldingSendToPharmacy = async (clickAuth: any) => {
    try {
      const data = JSON.parse(
        localStorage.getItem("epaconfirmpresctions-data")!
      )?.rowData;
      setLoad(true);
      handleShowsendTOPharmacyPrescriptionStatusPopUpClick();
      const params: any = new URLSearchParams();
      params.append("click", clickAuth);
      params.append("authenticationEventUUID", verifiedIdmeUuid);
      params.append(
        "authenticationUserUUID",
        localStorage.getItem("userIdmeUuid")
      );

      const bodyData = {
        doctorId: doctorId,
        epaIds: data,
        selectedAddress: clinicId,
      };
      const result: any = await EPAHoldingSendToPharmacy(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setEPASendToPharmacyData(result?.data?.response);
        setLoad(false);
        dispatch(loadingTopRibbon());
        setSendToPharmacyError("");
        localStorage.removeItem("userIdmeUuid");
        localStorage.removeItem("savedPreferenceForRoute");
      } else {
        setEPASendToPharmacyData([]);
        setLoad(false);
        setSendToPharmacyError(result?.data?.digitalRxStatusMessage);
      }
      localStorage.removeItem("userIdmeUuid");
    } catch (error) {
      setEPASendToPharmacyData([]);
      setSendToPharmacyError("Something went wrong, please try again later!");
    }
  };
  const prescriptionsEPAHoldingSendToPharmacyRefills = async (
    clickAuth: any
  ) => {
    try {
      const data = JSON.parse(
        localStorage.getItem("epaconfirmpresctions-data")!
      )?.rowData;
      setLoad(true);
      handleShowsendTOPharmacyPrescriptionStatusPopUpClick();
      const params: any = new URLSearchParams();
      params.append("click", clickAuth);
      params.append("authenticationEventUUID", verifiedIdmeUuid);
      params.append(
        "authenticationUserUUID",
        localStorage.getItem("userIdmeUuid")
      );
      const bodyData = {
        doctorId: doctorId,
        epaIds: data,
        selectedAddress: clinicId,
      };
      const result = await EPAHoldingSendToPharmacyForRefills(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setEPASendToPharmacyData(result?.data?.response);
        setLoad(false);
        dispatch(loadingTopRibbon());
        setSendToPharmacyError("");
        localStorage.removeItem("userIdmeUuid");
        localStorage.removeItem("savedPreferenceForRoute");
      } else {
        setSendToPharmacyError(result?.data?.digitalRxStatusMessage);
        setEPASendToPharmacyData([]);
        setLoad(false);
      }
    } catch (error) {
      setEPASendToPharmacyData([]);
      setSendToPharmacyError("Something went wrong, please try again later!");
    }
  };
  const submitPreferenceRoute = async () => {
    try {
      const body = {
        settingType: "MFA_ROUTE",
        enabled: true,
        savedPreference: localStorage.getItem("savedPreferenceForRoute"),
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        console.log("🚀 ~ submitPreference ~ result?.data:", result?.data);
      }
    } catch (error) {
      console.log("🚀 ~ submitPreference ~ error:", error);
    }
  };
  useEffect(() => {
    const type = JSON.parse(
      localStorage.getItem("epaconfirmpresctions-data")!
    )?.type;
    if (type === "newrx") {
      //(state?.type === "newrx") {
      epaConfirmPrescription();
    } else if (type === "refill") {
      epaConfirmPrescriptionForRefills();
    }

    return () => {
      localStorage.removeItem("epaconfirmpresctions-data");
    };
  }, []);
  useEffect(() => {
    const authCheck: string | null = searchParams.get("authorization");
    const type = JSON.parse(
      localStorage.getItem("epaconfirmpresctions-data")!
    )?.type;
    if (authCheck === "true" || verifiedIdmeUuid) {
      // send to pharmacy API call
      if (type === "newrx") {
        if (localStorage.getItem("savedPreferenceForRoute") === "0") {
          Promise.all([
            submitPreferenceRoute(),
            prescriptionsEPAHoldingSendToPharmacy(true),
          ]);
        } else {
          prescriptionsEPAHoldingSendToPharmacy(true);
        }
      } else if (type === "refill") {
        if (localStorage.getItem("savedPreferenceForRoute") === "0") {
          Promise.all([
            submitPreferenceRoute(),
            prescriptionsEPAHoldingSendToPharmacyRefills(true),
          ]);
        } else {
          prescriptionsEPAHoldingSendToPharmacyRefills(true);
        }
      }
    }
  }, [verifiedIdmeUuid]);
  return (
    <>
      <ContentStyle>
        {loading ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <ScrollBarStyle className="full">
            {data[0]?.epaHoldingQueueResponse?.map(
              (eachData: any, index: any) => (
                <SummaryBox style={{ padding: 10 }} key={index}>
                  <Grid
                    container
                    item
                    xs={12}
                    spacing={1}
                    alignItems="flex-start"
                    justifyContent="flex-start"
                  >
                    <Grid item xs={12} md={4}>
                      <Box className="lblval ">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Epa Id
                        </Typography>
                        <Typography
                          component="p"
                          style={{ wordBreak: "break-all" }}
                          variant="body2"
                        >
                          {eachData?.epaId}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Patient Name
                        </Typography>
                        <Typography component="div" variant="body2">
                          {eachData?.patientName}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Rx Date
                        </Typography>
                        <Typography component="div" variant="body2">
                          {eachData?.rxDate ??
                            moment(new Date()).format("MM/DD/YYYY")}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Fmlry. Status
                        </Typography>
                        <Typography component="div" variant="body2">
                          {eachData?.flmrlyStatus}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Box className="lblval">
                        <Typography
                          component="div"
                          variant="body2"
                          color={"primary"}
                          fontWeight={600}
                        >
                          {eachData?.drugDescription}
                        </Typography>
                        {eachData?.deaClassCode && (
                          <Typography
                            component="div"
                            className="ScheduledDrugLabel"
                            variant="body2"
                          >
                            {eachData?.deaClassCode}
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Co-Pay
                        </Typography>{" "}
                        <Typography component="div" variant="body2">
                          {eachData?.coPay}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          SIG
                        </Typography>{" "}
                        <Typography component="div" variant="body2">
                          {eachData?.sig}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Qualifier
                        </Typography>{" "}
                        <Typography component="div" variant="body2">
                          {eachData?.qualifier}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Quantity
                        </Typography>{" "}
                        <Typography component="div" variant="body2">
                          {eachData?.quantity}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          No. Of Refills
                        </Typography>{" "}
                        <Typography component="div" variant="body2">
                          {eachData?.noOfRefills}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Substitutions
                        </Typography>{" "}
                        <Typography component="div" variant="body2">
                          {eachData?.substitution}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box className="lblval">
                        <Typography
                          component="div"
                          variant="body2"
                          fontWeight={600}
                        >
                          Note to Pharmacist
                        </Typography>{" "}
                        <Typography component="div" variant="body2">
                          {eachData?.noteToPharmacist}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box className="lblval">
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={600}
                        >
                          Pharmacy
                        </Typography>
                        <Typography component="div" variant="body2">
                          {eachData?.pharmacyName}
                          <HtmlTooltip
                            placement="right"
                            arrow
                            title={
                              <PharmacyDetailsList
                                row={eachData?.pharmacyDetailsList}
                              />
                            }
                            className="w316"
                          >
                            <IconButton className="tooltip">
                              <img
                                src={InfoIcon}
                                alt="Tooltip"
                                loading="lazy"
                              />
                            </IconButton>
                          </HtmlTooltip>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box className="btns">
                        <YSButton
                          className={""}
                          children={"Adverse Effects"}
                          onClick={() => {
                            setDrugIdForAdverse(eachData?.drugId);
                            handleShowAdverseEffectPopUpClick();
                          }}
                          variant={"contained"}
                          size={"medium"}
                        />{" "}
                        <YSButton
                          className={""}
                          children={"Drug to Food Interactions"}
                          onClick={() => {
                            setDrugIdForAdverse(eachData?.drugId);
                            handleShowFoodPopUpClick();
                          }}
                          variant={"contained"}
                          size={"medium"}
                        />
                        <YSButton
                          className={""}
                          children={"Patient Education"}
                          onClick={() => {
                            handleShowPatientEduPopUpClick();
                          }}
                          variant={"contained"}
                          size={"medium"}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <SummaryInfo>
                    {" "}
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={1}
                      alignItems="center"
                      justifyContent="flex-start"
                    >
                      <Grid item xs={9} md={6}>
                        <Typography
                          component="div"
                          color={"primary"}
                          variant="subtitle2"
                          fontWeight={600}
                        >
                          Allergy and Drug Interactions
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={3} md={6} textAlign={"right"}>
                        <YSButton
                          key={index}
                          onClick={() => handleInfoClick(index)}
                          className=""
                          children={"Show"}
                          size={"small"}
                          type="button"
                          variant="contained"
                          startIcon={
                            openInfo[index] ? <HideIcon /> : <ShowIcon />
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Collapse in={openInfo[index]}>
                          <DrugAllergyInteractions
                            key={index}
                            eachData={eachData}
                          />
                        </Collapse>
                      </Grid>
                    </Grid>{" "}
                  </SummaryInfo>
                </SummaryBox>
              )
            )}
          </ScrollBarStyle>
        )}
        <Box style={{ textAlign: "center", width: "100%", padding: 20 }}>
          <YSButton
            onClick={() => {
              navigate("/epaholdingqueue");
            }}
            children={"Back"}
            size={"large"}
            type="button"
            color="primary"
            variant="outlined"
          />{" "}
          <YSButton
            onClick={() => {
              const type = JSON.parse(
                localStorage.getItem("epaconfirmpresctions-data")!
              )?.type;
              if (data[0]?.scheduleDrugFlag && UserServiceState?.epcsenabled) {
                handleShowSentPopupClick();
              } else if (type === "newrx") {
                prescriptionsEPAHoldingSendToPharmacy(false);
              } else if (type === "refill") {
                prescriptionsEPAHoldingSendToPharmacyRefills(false);
              }
            }}
            children={"Send to Pharmacy"}
            size={"large"}
            type="button"
            disabled={
              data[0]?.epaHoldingQueueResponse.length > 0 ? false : true
            }
            color="primary"
            variant="contained"
            startIcon={
              <img
                src={SendPharmacyIcon}
                alt="Send to Pharmacy"
                loading="lazy"
              />
            }
          />{" "}
        </Box>
      </ContentStyle>
      {/* Prescription status information popup */}
      <DialogPopup
        title="Prescription Status Information"
        windowsize={"sm"}
        show={prescriptionStatusPopUp}
        handleShowPopupClick={handleShowprescriptionStatusPopUpClick}
        handleHidePopupClick={handleHideprescriptionStatusPopUpClick}
      >
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={12}>
            {data[0]?.warnings?.map((each: any) => (
              <>
                <Typography
                  component={"div"}
                  variant={"body2"}
                  fontWeight={600}
                >
                  Details of <b>'{each?.status ?? ""}'</b> Epa Prescriptions:
                </Typography>

                <ul>
                  <li>{each?.warningMessage}</li>
                  <li>
                    Prescriptions that are in '{each?.status ?? ""}' status:
                  </li>
                  {each?.prescriptions?.map((item: any) => (
                    <ul>
                      <li>
                        {item?.patientName ?? ""} -{" "}
                        {item?.drugDescription ?? ""}
                      </li>
                    </ul>
                  ))}
                </ul>
              </>
            ))}
          </Grid>
        </Grid>
      </DialogPopup>
      {/* Prescription status popup */}
      <DialogPopup
        title="Prescription Status"
        windowsize={"sm"}
        show={sendTOPharmacyPrescriptionStatusPopUp}
        handleShowPopupClick={
          handleShowsendTOPharmacyPrescriptionStatusPopUpClick
        }
        handleHidePopupClick={
          handleHidesendTOPharmacyPrescriptionStatusPopUpClick
        }
      >
        {load ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : sendToPharmacyError ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"50vh"}
          >
            <Typography color="error" variant="subtitle2" fontWeight={600}>
              {sendToPharmacyError}
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12} textAlign={"left"}>
            {EPASendToPharmacyData?.map((each: any) => (
              <>
                <Typography
                  component="div"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  {each?.status
                    ? "Successful transactions :"
                    : "Failure transactions :"}
                </Typography>
                <ul>
                  <li>
                    <Typography
                      color={"primary"}
                      component={"div"}
                      variant={"body2"}
                      fontWeight={700}
                    >
                      {each?.patientName}
                    </Typography>
                    <Typography
                      color={"primary"}
                      component={"div"}
                      variant={"body2"}
                      fontWeight={600}
                    >
                      {each?.drugDescription}
                    </Typography>
                    <Typography component={"div"} variant={"body2"}>
                      {each?.statusDescription}
                    </Typography>
                    <Typography component={"div"} variant={"body2"}>
                      {each?.errorDescription}
                    </Typography>
                  </li>
                </ul>
              </>
            ))}
          </Grid>
        )}
      </DialogPopup>
      {/* Adverse Effect Popup */}
      <DialogPopup
        title="Adverse Effects"
        windowsize={"sm"}
        show={adverseEffectPopUp}
        handleShowPopupClick={handleShowAdverseEffectPopUpClick}
        handleHidePopupClick={handleHideAdverseEffectPopUpClick}
      >
        <AdverseEffectPOPUp drugIdforadverse={drugIdforadverse} />
      </DialogPopup>
      {/* epcs alert popup */}
      <DialogPopup
        title="EPCS Alert"
        windowsize={"sm"}
        show={faPopUp}
        handleShowPopupClick={handleShowSentPopupClick}
        handleHidePopupClick={handleHideSentPopupClick}
      >
        <EPCSAlert
          handleHideSentPopupClick={handleHideSentPopupClick}
          handleShowIDMEPopupClick={handleShowIDMEPopupClick}
          multiDea={true}
          URL={Alert2FA}
        />
      </DialogPopup>
      {/* IDME verification popup */}
      <DialogPopup
        title="Two-Factor Authentication"
        windowsize={"md"}
        show={iDmePopup}
        handleShowPopupClick={handleShowIDMEPopupClick}
        handleHidePopupClick={handleHideIDMEPopupClick}
      >
        <IDME
          URL={Alert2FA}
          setVerifiedByIdmeUuid={setVerifiedByIdmeUuid}
          handleHidePopupClick={handleHideIDMEPopupClick}
        />
      </DialogPopup>
      {/* food interactions */}
      <DialogPopup
        title="Drug to Food Interactions"
        windowsize={"sm"}
        show={foodPopUp}
        handleShowPopupClick={handleShowFoodPopUpClick}
        handleHidePopupClick={handleHideFoodPopUpClick}
      >
        <DrugToFoodInteractionPopUp drugIdforadverse={drugIdforadverse} />
      </DialogPopup>
      {/* Patient Education */}
      <DialogPopup
        title="Patient Education"
        windowsize={"sm"}
        show={patientEduPopUp}
        handleShowPopupClick={handleShowPatientEduPopUpClick}
        handleHidePopupClick={handleHidePatientEduPopUpClick}
      >
        <Typography>Info not available</Typography>
      </DialogPopup>
    </>
  );
}
